import API_URL from '../apiconfig';
import {
  NotificationPreferences,
  UpdateNotificationPreferencesPayload,
} from '../types/notifications';
import axios from './api';

export const getNotificationPreferences = async ({
  businessId,
}: {
  businessId?: string;
}) => {
  try {
    const preferencesResult = await axios.get(
      `${API_URL}/v1/notifications/preferences`,
      {
        params: {
          businessId,
        },
      },
    );

    return preferencesResult.data.result as NotificationPreferences;
  } catch (error) {
    throw new Error('Cannot get employee');
  }
};

export const updateNotificationPreferences = async (
  payload: UpdateNotificationPreferencesPayload,
) => {
  try {
    const preferencesResult = await axios.patch(
      `${API_URL}/v1/notifications/preferences`,
      payload,
    );

    return preferencesResult.data.result as NotificationPreferences;
  } catch (error) {
    throw new Error('Cannot update notification preferences');
  }
};
